import { mailEventEmitter, TRIGGER_MAIL_LIST_SCROLL_TO_TOP } from 'mini-mail-event-emitters';
import { useEffect } from 'react';

export const useScrollToTop = (callback: () => void) => {
    useEffect(() => {
        mailEventEmitter.on(TRIGGER_MAIL_LIST_SCROLL_TO_TOP, callback);

        return () => {
            mailEventEmitter.off(TRIGGER_MAIL_LIST_SCROLL_TO_TOP, callback);
        };
    }, []);
};
